import Sidebar from 'granite-admin/core/components/Sidebar';
import PageHeading from 'granite-admin/core/components/PageHeading';
import TopNavbar from 'granite-admin/core/components/TopNavbar';
import Notification from 'granite-admin/core/components/Notification';
const config = {
  HeaderComponent: null,
  FooterComponent: null,
  sidebarSettings: {
    align: 'left',
    width: '256px',
    showUserDropMenu: true,
    showUserProfile: false,
    showReferGranite: true,
    SideBarComponent: Sidebar,
    TopBarComponent: TopNavbar,
    layout: '',
    // leave empty to obey user pref otherwise use => "top_menu_bar/side_menu_bar"
    leftGroupVisibleItem: 8,
    // max num of item to show in left group for top navbar
    // getItemCount > a func by which project can decide item count to show as per screen size
    NotificationComponent: Notification
    // TopNavCustomLeftComp: Component > to add custom comp in left grid,
    // TopNavCustomRightComp: Component > to add custom comp in right grid,
  },

  showVerifyAccount: true,
  toast: {
    duration: 5000,
    closeOnClick: false,
    showCloseBtn: true,
    maxCount: 5
  },
  listOpenNewTab: true,
  showCreateOrganisation: true,
  websocketMappings: {
    NOTIFICATION: {
      //socket action name
      showToast: false,
      autoRedirect: false,
      redirectUrl: '',
      volatileStorage: false //to store onmessage's data in browser's storage if data is volatile
    },

    widgetDashboard: {
      showToast: true,
      toastMsg: 'Widget is refreshed with updated data',
      autoRedirect: true,
      redirectUrl: '/my-boards/:id/:name',
      volatileStorage: true
    }
  },
  projectAPIServices: ['accounts', 'organisations', 'granite'],
  advanceMasterConfig: true,
  subdomainRedirectEnabled: false,
  isBGWidgetToggleActive: true,
  showSkeletonLoader: true,
  dropContentSettings: {
    DropContent: null,
    showFilterLabel: true
  },
  verticalMenu: {
    VerticalMenu: null
  },
  pageHeading: {
    PageHeading
  },
  filterComponent: {
    FilterComponent: null
  },
  loginDetails: {
    ProjectLoginForm: null
  },
  registerDetails: {
    ProjectRegisterForm: null
  },
  helpText: {
    icon: null
  },
  widgetDataTable: 'dataTableV3',
  showProductConsole: true,
  sliderWidth: '600px'
};
export default config;